import React from 'react';

// Styles
import { StyledCenteredPlanSectionHeader, StyledLogoContainer } from '../plansummary.styled';

const PlanLogoAndLink = ({ plan }) => (
    <>
        <StyledLogoContainer>
            <img src={plan.planLogoUrl} alt={`${plan.issuerName} logo`} data-testid="plan-logo" />
        </StyledLogoContainer>
        <StyledCenteredPlanSectionHeader>
            <a href="javascript:void(0)" data-testid="plan-name">
                {plan.planName}
            </a>
        </StyledCenteredPlanSectionHeader>
    </>
);

export default PlanLogoAndLink;
